import { useTheme } from 'next-themes';
import { type ReactNode } from 'react';

import { PipeLogoIcon } from '../pipe-logo';
import dotBgDark from './assets/dot-bg.dark.png';
import dotBgLight from './assets/dot-bg.light.png';
import * as styles from './index.css';

// PIPE fork: the auth/other-page top bar is de-branded — no AFFiNE logo, no external
// affine.pro nav links, and no "Download app" button. Just the PIPE logo + wordmark
// linking home (the logo reuses the shared `PipeLogoIcon`).
export const AffineOtherPageLayout = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { resolvedTheme } = useTheme();
  const backgroundImage =
    resolvedTheme === 'dark' && dotBgDark ? dotBgDark : dotBgLight;

  return (
    <div
      className={styles.root}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {BUILD_CONFIG.isElectron ? (
        <div className={styles.draggableHeader} />
      ) : (
        <div className={styles.topNav}>
          <a
            href="/"
            rel="noreferrer"
            className={styles.affineLogo}
            style={{ display: 'flex', alignItems: 'center', gap: 10 }}
          >
            <PipeLogoIcon width={28} height={28} aria-hidden />
            <span
              style={{ fontWeight: 700, fontSize: 20, letterSpacing: '0.06em' }}
            >
              PIPE
            </span>
          </a>
        </div>
      )}

      {children}
    </div>
  );
};
